// extracted by mini-css-extract-plugin
export default {"container":"_8DlYu","box":"PaJr3","title":"cj-6P","subtitle":"fcxaQ","button":"MmA9D"};